import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import DVDLogo from "../../DVDLogo";

const Screen = styled.div`
  width: 100%;
  height: 100%;
  background: #0b0b10;
  overflow: hidden;
`;

const ScreensaverApp = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () =>
      setSize({ width: el.clientWidth, height: el.clientHeight });
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <Screen ref={ref}>
      {size.width > 0 && size.height > 0 && (
        <svg width={size.width} height={size.height}>
          <DVDLogo
            key={`${size.width}x${size.height}`}
            width={size.width}
            height={size.height}
          />
        </svg>
      )}
    </Screen>
  );
};

export default ScreensaverApp;
